// 会计
const othersPay = () => import('../pages/othersPay/index.vue');
const paySuccess = () => import('../pages/othersPay/paySuccess.vue');
export default [
  {
    path: '/othersPay',
    component: othersPay,
  },
  {
    path: '/othersPay/paySuccess',
    component: paySuccess,
  },
];
